import { NgModule } from '@angular/core';

import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatBadgeModule } from '@angular/material/badge';
import { MatSortModule } from '@angular/material/sort';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatMomentDateModule, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'
@NgModule({
  imports: [
    MatTableModule,
    MatPaginatorModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule,
    MatSnackBarModule,
    MatCardModule,
    MatSelectModule,
    MatTooltipModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatSidenavModule,
    MatProgressBarModule,
    MatListModule,
    MatTabsModule,
    MatRadioModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatBadgeModule,
    MatSortModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatChipsModule,
    NgxMatSelectSearchModule
  ],
  exports: [
    MatTableModule,
    MatPaginatorModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule,
    MatSnackBarModule,
    MatCardModule,
    MatSelectModule,
    MatTooltipModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatSidenavModule,
    MatProgressBarModule,
    MatListModule,
    MatTabsModule,
    MatRadioModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatBadgeModule,
    MatSortModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatMomentDateModule,
    NgxMatSelectSearchModule,
    
  ],
  providers: [
      {​​​​​​​​
  provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  useValue: {​​​​​​​​ useUtc: false }​​​​​​​​
      }​​​​​​​​
  ]  
})
export class SharedMaterialModule { }
